import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { ShopLocatorStateModule } from "@hermes/states/shop-locator";

import { ShopLocationsEffects } from "./shop-locations.effects";
import { ShopLocationsFacade } from "./shop-locations.facade";
import * as fromShopLocations from "./shop-locations.reducer";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShopLocations.shopLocationsFeatureKey,
            fromShopLocations.reducer,
        ),
        EffectsModule.forFeature([ShopLocationsEffects]),
        ShopLocatorStateModule,
    ],
    providers: [ShopLocationsFacade],
})
export class ShopLocationsStateModule {}
